export default __webpack_public_path__ + "3ce331f8400dd928588047037e742560.svg";